import { cleanNumber } from "helpers/cleanNumbers";

// El SAT no acepta partidas de facturación global por debajo de 1 litro (CRM-3022).
export const MIN_INVOICE_QUANTITY = 1;

export const isInvalidQuantity = (quantity) =>
  cleanNumber(quantity) < MIN_INVOICE_QUANTITY;

// Devuelve las partidas del desglose cuya cantidad no alcanza el mínimo timbrable.
export const getInvalidQuantityPayments = (taxBreakdown = []) =>
  (taxBreakdown || []).flatMap(({ taxRate, payments }) =>
    Object.entries(payments || {})
      .filter(([, payment]) => isInvalidQuantity(payment?.quantity))
      .map(([key, payment]) => ({
        taxRate,
        key,
        name: payment?.name || key,
        quantity: cleanNumber(payment?.quantity),
      })),
  );

export const buildInvalidQuantityMessage = (invalidPayments = []) => {
  const detail = invalidPayments
    .map(({ taxRate, name }) => `${taxRate}% - ${name}`)
    .join(", ");

  return `No se puede timbrar: las siguientes partidas tienen menos de ${MIN_INVOICE_QUANTITY} Lt: ${detail}. Corrige las cantidades para timbrar todo.`;
};
